export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_0be19ea1-412f-478f-9161-6aaf4c9a440c/artifacts/50wboy37_image.png",
  founders: {
    hisen: "https://customer-assets.emergentagent.com/job_versorger-portal/artifacts/vmu2u7uq_image.png",
    anil: "https://customer-assets.emergentagent.com/job_versorger-portal/artifacts/rkzsrl3j_image.png",
  },
  dashboardMockup:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  academy:
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  quality:
    "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const COMPANY = {
  name: "faktor-direkt",
  street: "Emsdettener Str. 59",
  city: "48485 Neuenkirchen",
  phone: "+49 176 76797767",
  phoneRaw: "+4917676797767",
  email: "info@faktordirekt.de",
  managingDirectors: "Anil Dogan, Hisen Kajtazi",
};
